import request from '@/utils/request'


// 查询搜索列表
export function listSearch(query) {
  return request({
    url: '/search/search/list',
    method: 'get',
    params: query
  })
}

// 查询搜索分页
export function pageSearch(query) {
  return request({
    url: '/search/search/page',
    method: 'get',
    params: query
  })
}

// 查询搜索详细
export function getSearch(data) {
  return request({
    url: '/search/search/detail',
    method: 'get',
    params: data
  })
}

// 新增搜索
export function addSearch(data) {
  return request({
    url: '/search/search/add',
    method: 'post',
    data: data
  })
}

// 修改搜索
export function updateSearch(data) {
  return request({
    url: '/search/search/edit',
    method: 'post',
    data: data
  })
}

// 删除搜索
export function delSearch(data) {
  return request({
    url: '/search/search/delete',
    method: 'post',
    data: data
  })
}
